import * as angular from "angular";
import {IController} from "angular";
import {ResizeService} from "../../../commons/services/resize-service.service";

export class AgentItineraryTimelineCtrl implements IController {

  itinerary: any;
  tasks: any;
  relatedItineraries: any;
  relatedTasks: any;
  from: any;
  to: any;
  canEdit: any;
  selectedTaskId: any;
  hiddenAgentIds: any;

  onTaskSelection: Function;
  onToggleAgent: Function;
  onAgentSelect: Function;
  onChangeItineraryOrder: Function;

  private timelineEnabled: boolean;
  private isMouseVerticalDown: boolean;
  private highlightedTaskId: any;

  constructor(private resizerService: ResizeService, private resizeService: ResizeService) {
  }

  $onInit() {
    this.timelineEnabled = false;
    this.isMouseVerticalDown = false;
  }

  onToggleTimeline() {
    this.timelineEnabled = !this.timelineEnabled;
    this.resizeService.resize();
  }

  onTaskRightClick(task, $event) {
    // var actions = planningConstants.activityActions;
    // CommonsService.openActionPanel(actions, $event)
    //     .then(function(reason) {
    //
    //     })
    //     .catch(function(reason) {
    //        $log.info('Action Panel Closed', reason);
    //     });
  }

  onTaskHighlight(task, $event) {
    this.highlightedTaskId = task.id;
  }
}

angular
  .module('bringoz.admin.agents')
  .component('agentItineraryTimeline', {
    bindings: {
      itinerary: '<',
      tasks: '<?',
      relatedItineraries: '<?',
      relatedTasks: '<?',
      from: '<',
      to: '<',
      canEdit: '<',
      selectedTaskId: '<',
      hiddenAgentIds: '<',
      onTaskSelection: '&',
      onToggleAgent: '&',
      onAgentSelect: '&',
      onChangeItineraryOrder: '&'
    },
    template: require('./agent-itinerary-timeline.html').default,
    controller: AgentItineraryTimelineCtrl
  });
